import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LearnMoreButton from './LearnMoreButton';
import styles from './About.module.scss';
import Image from 'react-bootstrap/Image';

const apiUrl = process.env.REACT_APP_API_URL || '';

const About = () => {
  const [myAge, setMyAge] = React.useState<number | null>(null);
  useEffect(() => {
    fetch(apiUrl + '/public/info')
      .then(async (response) => {
        const responseJson = await response.json();
        if (!response.ok) {
          console.error('Erro na resposta da API: ', responseJson);
          return Promise.reject(responseJson.message || 'Ocorreu um erro desconhecido.');
        }
        return responseJson;
      })
      .then((data) => {
        const birthday = data.birthday; // Supondo que a data de nascimento esteja no formato 'YYYY-MM-DD'

        const birthDate = new Date(birthday);
        const currentDate = new Date();
        const age = Math.floor((currentDate.getTime() - birthDate.getTime()) / (1000 * 60 * 60 * 24 * 365));
        setMyAge(age);
      })
      .catch((error) => {
        console.error('Erro ao buscar informações: ', error);
      });

  }, []);


  return (
    <Container className={[styles["data-container"], styles["container"]].join(" ")} id="sobre">
      <Row className={styles["data-content"]} id="quem-sou-eu">
        <Col md="6" className={styles["text-content"]}>
          <h2>Sobre mim</h2>
          <p>Olá. Meu nome é Mayara, tenho {myAge} anos, e vou falar um pouco sobre mim. Sou cristã, casada, amo livros, azeitonas e açaí.</p>
          <p>Acredito que a alimentação deve ser leve, equilibrada e acolhedora, e que cada pessoa tem uma relação única com a comida, e isso merece respeito e escuta ativa. A alimentação vai além da simples ingestão de nutrientes; envolve um contexto que precisa ser considerado com cuidado.</p>
          <p>Acompanho pacientes em reeducação alimentar e entendo que mudar hábitos é um processo gradual, que exige, acima de tudo, paciência e constância. Falo isso não apenas com base no conhecimento adquirido, mas também na minha própria experiência. Há {(myAge ?? 17) - 17} anos, compreendi que uma alimentação saudável é uma forma importante de autocuidado, pois o cuidado nutricional transforma vidas.</p>
          <p className={styles["formacao"]}>Formação:</p>
          <ul className={styles["formacao"]}>
            <li>Nutricionista pela Universidade Federal do Rio de Janeiro (UFRJ)</li>
            <li>Pós-graduanda em Terapia nutricional (UFRJ)</li>
            <li>Aperfeiçoamento em cuidados paliativos no Instituto Nacional de Câncer (INCA)</li>
            <li>Mestranda em nutrição humana (UFRJ)</li>
          </ul>
          <div className={styles["learn-more-div"]}>
            <LearnMoreButton
              onClick={(e) => {
                const formacao = document.querySelectorAll(`.${styles['formacao']}`) as NodeListOf<HTMLElement>;
                const learnMoreButton = e.currentTarget as HTMLButtonElement;

                formacao.forEach((item) => {
                  item.style.display = 'block';
                });
                learnMoreButton.style.display = 'none';
              }}
            >
              Saiba mais
            </LearnMoreButton>
          </div>
        </Col>
        <Col md="6" className={styles["img-content"]}>
          <Image src="/assets/index/quem_sou_eu.png" className={styles["img-mayara"]} alt="Mayara" rounded />
        </Col>
      </Row>
    </Container>
  );
}

export default About;
